/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicTeamItem } from '../models/PublicTeamItem';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PublicTeamsService {
    /**
     * @returns PublicTeamItem OK
     * @throws ApiError
     */
    public static getApiPublicTeams(): CancelablePromise<Array<PublicTeamItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/public/teams',
        });
    }
    /**
     * @param domain
     * @returns any OK
     * @throws ApiError
     */
    public static getApiPublicTeamsResolve(
        domain?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/public/teams/resolve',
            query: {
                'domain': domain,
            },
        });
    }
}
